export const getCustomerSelector = state => state.customers.customer
export const getCustomerIdSelector = state => state.customers.customerId
export const getCustomerCompanySelector = state => state.customers.company
export const getCustomerFetchStatus = state => state.customers.fetching
export const getCustomerReloadingSelector = state => state.customers.reloading
